/**
 * A recreation site's vehicle capacity, where "no cap" is a real answer.
 *
 * TAKES `unknown`, like the other custom formatters: a null capacity means the site is
 * unlimited, and the API omits the key entirely, so the CRUD hands this the whole row
 * object. Anything that is not a number is therefore "no cap recorded".
 *
 * Renders the word rather than a blank, because an empty cell here would read as missing
 * data when it actually means "as many as turn up".
 */
export function capacityLabel(value: unknown): string {
    const num = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
    if (!Number.isFinite(num)) {
        return '<span class="text-body-secondary">Unlimited</span>';
    }

    return String(num);
}
